import { useEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { setShowSearch } from "../../store/appConfigsSlice";

import { SupportCenter } from "../../components/support";

const SupportPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return <SupportCenter />;
};

export default withTranslation()(SupportPage);
